export interface TreatmentAssignmentRule {
    readonly id: number;
    readonly name: string;
    readonly isActive: boolean;
    readonly treatmentTypeOriginalId?: number | null;
    readonly treatmentTypeName?: string | null;
    /** Empty means the rule covers every sub type of the treatment type. */
    readonly treatmentSubTypeOriginalIds: readonly number[];
    readonly treatmentSubTypeNames: readonly string[];
    readonly organizationId?: string | null;
    readonly officeId?: string | null;
    readonly officeName?: string | null;
    readonly region?: number | null;
    readonly stripeProductType?: number | null;
    readonly designerUserId?: string | null;
    readonly designerFullName?: string | null;
    readonly designerEmail?: string | null;
    /** Specificity score; the highest-scoring matching rule wins. */
    readonly score: number;
    readonly createdDate: string;
    readonly modifiedDate: string;
    readonly modifiedBy?: string | null;
}
